var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('page-title',[_vm._v("Edit Panel")]),(_vm.panel)?_c('panel-form',{attrs:{"panel":_vm.panel},on:{"submit":_vm.onSave}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }